export default "__VITE_ASSET__C6Awiq8q__"